// First-party acquisition attribution (UTM / campaign ids / referrer), kept in
// sessionStorage for the current tab so it survives SPA navigation and the
// Google OAuth round-trip. Sent once to the backend at registration.
export const ATTR_KEY = "ind_attribution";
export const ATTR_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "gclid"];

function read() {
  try {
    return JSON.parse(window.sessionStorage.getItem(ATTR_KEY) || "null");
  } catch {
    return null;
  }
}

function externalReferrer() {
  try {
    const r = document.referrer;
    if (!r) return undefined;
    const host = new URL(r).hostname;
    if (host === window.location.hostname || /emergentagent\.com$|accounts\.google\./.test(host)) return undefined;
    return r.slice(0, 300);
  } catch {
    return undefined;
  }
}

// Called once at app load. First touch with campaign params wins for the tab.
export function captureAttribution() {
  if (typeof window === "undefined") return null;
  const existing = read();
  const p = new URLSearchParams(window.location.search);
  const params = {};
  for (const k of ATTR_PARAMS) {
    const v = p.get(k);
    if (v) params[k] = v.slice(0, 200);
  }
  const hasCampaign = Object.keys(params).length > 0;
  if (existing && (!hasCampaign || ATTR_PARAMS.some((k) => existing[k]))) return existing;
  const ref = externalReferrer();
  const out = { ...params, landing_page: window.location.pathname };
  if (ref) out.referrer = ref;
  try {
    window.sessionStorage.setItem(ATTR_KEY, JSON.stringify(out));
  } catch {}
  return out;
}

export function getAttribution() {
  return read() || {};
}

// Query string with campaign params, used when moving the user to another browser.
export function attributionQuery() {
  const a = getAttribution();
  const q = new URLSearchParams();
  for (const k of ATTR_PARAMS) if (a[k]) q.set(k, a[k]);
  return q.toString();
}
